export {
  DEFAULT_LOCK_MESSAGE,
  MINIMUM_LENGTH_OF_COMMENT,
  TAB_STATUS_CONS,
  TAB_STATUS_TODO,
  TITLE,
} from '../constant';

export const CERTIFICATION_CLOSE_TIMEOUT = 1000;
